import React, { useState, useEffect } from 'react';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import './style.scss';
import { useSelector } from 'react-redux';
import methodModel from '../../methods/methods';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/global/layout';
import { Tooltip } from 'antd';
import { toast } from 'react-toastify';
import 'react-quill/dist/quill.snow.css';
import SelectDropdown from '../../components/common/SelectDropdown';

const AddEditMenu = () => {
  const { id } = useParams();
  const [form, setform] = useState({
    name: "",
    url: "",
  });
  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const user = useSelector((state) => state.user);
  const formValidation = [{ key: 'name', required: true },
  { key: 'url', required: true }
  ];


  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!form?.url || !form?.name) {
      return
    }
    let invalid = methodModel.getFormError(formValidation, form);
    if (invalid) return;
    let method = 'post';
    let url = 'items';
    let value = {
      name: form.name,
      url: form?.url,

    };
    if (id) {
      method = 'put';
      url = 'items';
      value.id = JSON.parse(id);
    } else {
      value.addedBy = user._id;
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        toast.success(res?.message);
        history(`/menu`);
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };


  useEffect(() => {
    if (id) {
      loader(true)
      ApiClient.get(`items?id=${id}`).then((res) => {
        if (res.success) {
          setform({
            ...form,
            name: res?.data?.name,
            url: res?.data?.url
          })
          loader(false)
        }
      })
    }
  }, [id])

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <button
                  type="button"
                  onClick={(e) => back()}
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   discard mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </button>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? 'Edit' : 'Add'} Menu Item
                </h3>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              <>
                <div className="col-span-12 md:col-span-6">
                  <label>
                    Name<span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form?.name}
                    onChange={(e) => setform({ ...form, name: e.target.value })}
                    required
                  />
                </div>
                <div className="col-span-12 md:col-span-6">
                  <label>
                    Url<span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form?.url}
                    onChange={(e) => setform({ ...form, url: e.target.value })}
                    required
                  />
                </div>
              </>
            </div>

            <div className="flex justify-end mt-3">
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditMenu;
